import { lazy, Suspense } from "react";
import Loader from '../custom/loader/main';

const Main = lazy(() => import('../components/setup/users/userDetails/details'));

const UserDetails = () => {
    return (
        <Suspense fallback={<Loader/>}>
            <Main/>
        </Suspense>
    )
}

export default UserDetails;